import Icon from '../components/Icon';

const DifficultyModerate = Icon(
  'difficulty-moderate',
  <>
    <path d="M4.5 7.5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3z" />
  </>
);

export default DifficultyModerate;
